<div>
    <gb-ui-header
      [imageDetail]="imageDetail"
      [navLinks]="navigation"
      [showSearch]="false"
      [displayLinksBelow]="true"
    >
      <!-- <ng-template #utilityArea>
        <div class="d-flex">
          <button class="btn btn-primary" (click)="bookAppointment()">
            Book now
          </button>
        </div>
      </ng-template> -->
    </gb-ui-header>

    <div class="feedback-banner">
      <div class="govuk-width-container feedback-banner__inner">
        <span class="feedback-banner__tag">New</span>
        <p class="feedback-banner__text">
          We've launched new service options and are monitoring their performance. Leave your feedback 
          <a
            class="govuk-link feedback-banner__link"
            [routerLink]="communicationLink"
            >here</a
          >.
        </p>
      </div>
    </div>
  </div>
